export const displayFormat = (input: number) => {
	return Number(input).toLocaleString(undefined, {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
		minimumIntegerDigits: 1,
	})
}